import { render, staticRenderFns } from "./business-unit-settings-configuration.component.vue?vue&type=template&id=deebcbae&scoped=true&"
import script from "./business-unit-settings-configuration.component.vue?vue&type=script&lang=ts&"
export * from "./business-unit-settings-configuration.component.vue?vue&type=script&lang=ts&"
import style0 from "./business-unit-settings-configuration.component.vue?vue&type=style&index=0&id=deebcbae&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deebcbae",
  null
  
)

export default component.exports